import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from 'app/auth-guard.service';

import {CreateTaskComponent} from './create-task/create-task.component';
import {ContactComponent} from './contact/contact.component';
import {GroupComponent} from './contact/group/group.component';
import {TemplatesComponent} from './templates/templates.component';
import {WorkflowComponent} from './workflow/workflow.component';
import {SignDocumentComponent} from './sign-document/sign-document.component';
import {AuthenSignComponent} from './authen-sign/authen-sign.component';
import {TasksComponent} from './tasks/tasks.component';
import {MainSiteFlowComponent} from './main-site-flow/main-site-flow.component';
import {MailFlowComponent} from './mail-flow/mail-flow.component';
import {SignDialogComponent} from './sign-document/sign-dialog/sign-dialog.component';
import {AutoApproveComponent} from './auto-approve/auto-approve.component';
import {ExternalSignComponent} from "./external-sign/external-sign.component";
import {ExternalCompletedComponent} from "./external-completed/external-completed.component";

const routes: Routes = [
   {
      path: 'contact',
      component: ContactComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'group',
      component: GroupComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'templates',
      component: TemplatesComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'workflows',
      component: WorkflowComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'signdoc/:taskid/:device',
      component: SignDocumentComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'signdoc/:taskid',
      component: SignDocumentComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'extsigndoc/:taskid/:key',
      component: SignDocumentComponent
   },
   {
      path: 'firstsign/:taskid',
      component: AuthenSignComponent
   },
   {
      path: 'create-task',
      component: CreateTaskComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'create-template',
      component: CreateTaskComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'tasks/:status',
      component: TasksComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'tasks/:status/:search',
      component: TasksComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'tasks/:status/:t1&:t2&:t3&:t4&:t5&:t6&:t7&:t8',
      component: TasksComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'site-flow',
      component: MainSiteFlowComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'mail-flow',
      component: MailFlowComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'sign-off/:doc-id/:temp-id',
      component: SignDialogComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'sign-off/:doc-id',
      component: SignDialogComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'auto-approve',
      component: AutoApproveComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'extsign/:taskid/:key',
      component: ExternalSignComponent
   },
   {
      path: 'extsigndoc/completed/:taskid/:key',
      component: ExternalCompletedComponent
   },
];

@NgModule({
   imports: [RouterModule.forRoot(routes)],
   exports: [RouterModule]
})
export class ESignatureRoutingModule {
}
